var getSelectedNames = function getSelectedNames(selectedValues) {
  return selectedValues.map(function (v) {
    return v.name;
  }).join(", ");
};

export default getSelectedNames;